module.exports = "<p>\n  adminusers works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/adminusers/adminusers.component.html
// module id = ./src/app/adminusers/adminusers.component.html
// module chunks = main